<script setup lang="ts">
import { UiSnackbar } from "@packages/component-library";
import { ref, computed, onMounted, onUnmounted } from "vue";
import type { Component } from "vue";
import { eventBus } from "@/package/helpers/eventBus";
// todo заменить на IShackbar

interface Item {
  id: number;
  isOpen: boolean;
  title: string;
  text: string;
  componentIcon: Component;
  timeActive: string;
  type: "neutral" | "info" | "warning" | "success" | "error";
  showClose: boolean;
}

onMounted(() => {
  eventBus.on("global-snackbar", addSnackbar);
});

onUnmounted(() => {
  eventBus.off("global-snackbar", addSnackbar);
});

const snackbars = ref<Item[]>([]);

const maxId = computed(() => {
  return snackbars.value.reduce((id, item): number => {
    return id < item.id ? item.id : id;
  }, 0);
});

const addSnackbar = (data: Item) => {
  const snackbar = Object.assign(
    {
      isOpen: true,
      id: maxId.value + 1,
    },
    data
  );

  snackbars.value.push(snackbar);

  setTimeout(() => {
    deleteSnackbar(snackbar.id);
  }, 4000);
};

const deleteSnackbar = (id: number): void => {
  snackbars.value = snackbars.value.filter((item) => item.id !== id);
};
</script>

<template>
  <div class="snackbar__wrapper">
    <TransitionGroup name="snackbar">
      <UiSnackbar
        v-for="item in snackbars"
        :key="item.id"
        class="snackbar__item elevation-shadow-low"
        :text="item.text"
        z-index="1001"
        :title="item.title"
        :type="item.type"
        :show-close="item.showClose"
        @close="deleteSnackbar(item.id)"
      />
    </TransitionGroup>
  </div>
</template>

<style lang="scss" scoped>
.snackbar__wrapper {
  position: fixed;
  top: 40px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;

  &:deep(.ui-snackbar) {
    position: static;
  }
}

.snackbar-enter-active,
.snackbar-leave-active {
  transition: transform 0.3s ease;
}

.snackbar-enter-from {
  transform: translateX(120%);
}

.snackbar-leave-to {
  transform: scale(0);
}
</style>
